module.exports = __webpack_public_path__ + "img/query.9081b03c.png";